import React, { useEffect } from "react";
import { formatColorTooltip } from "lib/Colors/formatColorTooltip";
import { scheduleTooltipRebuild } from "views/components/Tooltip";
import style from "./style.module.css";

export const COLOR_SAMPLE_TOOLTIP_ID = "colorSampleTooltip";

const ColorSample = ({
  color,
  onClick,
  highlight = false,
  isSquare = false,
  tooltip,
  tooltipDisabled = false
}) => {
  const tooltipText = tooltip ?? formatColorTooltip(color);
  const hasTooltip = !tooltipDisabled && !!tooltipText;
  const tooltipProps = hasTooltip
    ? { "data-tip": tooltipText, "data-for": COLOR_SAMPLE_TOOLTIP_ID }
    : {};

  useEffect(() => {
    if (hasTooltip) scheduleTooltipRebuild();
  }, [hasTooltip, tooltipText]);

  return (
    <div
      {...tooltipProps}
      onClick={onClick}
      className={[
        style.colorSample,
        color === "transparent" ? style.colorSampleTransparent : "",
        isSquare ? style.colorSampleSquare : ""
      ].join(" ")}
      style={{
        backgroundColor: color === "transparent" ? "#ffffff" : color,
        boxShadow: highlight ? "0 0 0 2px white, 0 0 0 3px #1c1d1e" : "none"
      }}
    />
  );
};

export default ColorSample;
